<template>
  <div class="home">
    <div class="Page-Content" style="overflow: hidden">
      <swiper
        class="swiper swiperInformation"
        :options="swiperOption"
        ref="swiperOption"
      >
      <swiper-slide>
        <div class="w40" style="position: relative;height: 90%;margin-top: 0%;">
          <img style="position: absolute;left: 0;height: 100%;object-fit: cover;border: 10px solid  #ab855c;" src="@/assets/172-img/172-6C6D LaVille-V2.jpg" alt="">
          <h1 style="position: absolute;text-align: start;top: 10px;left: 20px;" class="ani"
              swiper-animate-effect="fadeInLeft"
              swiper-animate-duration="2.5s">
            BESPOKE ATELIER COUTURE: <br>
            A MASTERCLASS IN <br>
            HANDCRAFTED LUXURY <br>
          </h1>
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="flex-center">
          <h1 style="font-size: 35px;letter-spacing: 2px;font-family: 'haborocontrastnormregular';" class="ani"
              swiper-animate-effect="fadeInLeft"
              swiper-animate-duration="1.5s">
              HEART OF THE CITY 
              SOUL OF THE BEACH
            </h1>
            <p style="font-size: 18px;line-height: 26px;letter-spacing: 1px;" class="w50 ani"
              swiper-animate-effect="fadeIn"
              swiper-animate-duration="1.5s">
              Welcome to Arina East Residences, an exquisite masterpiece that redefines luxury
              living in the prime Marina East precinct. The development blends architectural
              brilliance with sublime serenity, creating an extraordinary dwelling for many
              generations to treasure. 
            </p>
            <p style="font-size: 18px;line-height: 26px;letter-spacing: 1px;" class="w50 ani"
              swiper-animate-effect="fadeIn"
              swiper-animate-duration="1.5s">
              Its coveted freehold status ensures that Arina East is not just a residence but a
              legacy in the marking. This is a ease opportunity to own a piece of Singapore’s rich
              coastal heritage. Once rooted in shipbuilding, Marina East has evolved into an elite
              waterfront enclave, providing the perfect backdrop for a life well-lived.
            </p>

        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="home-flex-center">
          <div class="w50">
            <img style="width: calc(100% - 20px);object-fit: cover;padding: 10px;background-color: #ab855c;" src="@/assets/172-img/1-2.jpg" alt="">
            <p style="text-align: start;margin-left: 10px;" class="ani"
              swiper-animate-effect="fadeInLeft"
              swiper-animate-duration="1.5s">
              Marina East bridges the tranquil charm of the East with the excitement of the <br>
              city. Lush greenery and calm waterbodies intersect with efficient transport <br>
              and attractive work and lifestyle amenities. All this, combined with excellent <br>
              residential facilities makes Arina East enviable as a forever premium resort home.
            </p>
          </div>
          <h1 style="text-align: start;margin-left: 20px;" class="ani"
              swiper-animate-effect="fadeInRight"
              swiper-animate-duration="1.5s">NATURE AND SERENITY IN A <br>
            PREMIUM FREEHOLD OASIS</h1>
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="home-flex-center">
          <div class="w50">
            <img style="width: calc(100% - 20px);object-fit: cover;padding: 10px;background-color: #ab855c;" src="@/assets/172-img/172-6C6D LaVille-v4-1.jpg" alt="">
            <p style="text-align: start;margin-left: 10px;" class="ani"
              swiper-animate-effect="fadeInLeft"
              swiper-animate-duration="1.5s">
              Stunning 270-degree view of a dynamic horizon welcome every resident’s gaze. From an <br>
              elevated vantage point, delight in knowing that home is tranquil sanctuary amidst an <br>
              ever-evolving bustling community in the charming East.
            </p>
          </div>
          <h1 style="text-align: start;margin-left: 20px;" class="ani"
              swiper-animate-effect="fadeInRight"
              swiper-animate-duration="1.5s">
            RISING ABOVE TO <br>
            BRING VIBRANCY<br>
            TO YOUR BALCONY
          </h1>
        </div>
      </swiper-slide>
      </swiper>
      <div class="swiper-pagination" slot="pagination"></div>
      <div class="swiper-button-prev" style="left: 5%; top: 45%">
        <img src="@/assets/btn/left1.png" alt="" />
      </div>
      <div class="swiper-button-next" style="right: 5%; top: 45%">
        <img src="@/assets/btn/right1.png" alt="" />
      </div>
    </div>

    <div class="Page-Content home-bg1 col" >
      <h2 style="margin: 0 30px;color: #ab855c;text-shadow: 3px 1px 1px #000;">LUXURY AND TIMELESS ELEGANCE AT MARINA EAST
      </h2>
    </div>
    <div class="Page-Content" style="height: auto !important;">
      <h1 class="mt-75">LOCATION MAP</h1>
      <div class="home-flex-center" style="width: 100%;height: 100%;" >
        <img @click="showMaps()" style="max-width: 80%;max-height: 100%;display: block;" src="@/assets/172-img/map.png" alt="">
      </div>
    </div>
    <!-- <div class="Page-Content col" style="height: auto !important;">
      <h1 style="text-align: center;">
        BESPOKE ATELIER COUTURE: <br>
        A MASTERCLASS IN <br>
        HANDCRAFTED LUXURY <br>
      </h1>
    </div> -->
    <div class="Page-Content col" style="height: auto !important;">
      <h1 class="mt-75">VIRTUAL TOUR</h1>
      <div class="gallery-group">
        <div class="gallery-item growFromScaleAnimation" @click="showVr({type:'vr',media:'https://arinaeastresidences.com.sg/VR/A1/'})">
          <div class="item-img col">
            <img class="" src="@/assets/gallery/typeA.png" alt="" />
            <h2>Type A</h2>
          </div>
        </div>
        <div class="gallery-item growFromScaleAnimation" @click="showVr({type:'vr',media:'https://arinaeastresidences.com.sg/VR/B2/'})">
          <div class="item-img col">
            <img class="" src="@/assets/gallery/typeB2.png" alt="" />
            <h2>Type B2</h2>
          </div>
        </div>
        <div class="gallery-item growFromScaleAnimation" @click="showVr({type:'vr',media:'https://arinaeastresidences.com.sg/VR/D2b/'})">
          <div class="item-img col">
            <img class="" src="@/assets/gallery/typeD2a.png" alt="" />
            <h2>Type D2a</h2>
          </div>
        </div>
      </div>
      <h1 class="mt-75">GALLERY</h1>
      <img @click="showImg(item)" style="max-width: 80%;margin: 20px;" v-for="(item,index) in imglist" :key="index" :src="item.cover" alt="">
    </div>
    <div class="col mt-75 mb-75">
      <h4 style="margin: 20px 0 0 0;font-size: 22px;">Please contact us for a viewing appointment.</h4>
      <div class="home-phone-btn" @click="calltype = true">
        <img style="width: 45px;" src="@/assets/btn/phone-btn.png" alt="phone">
        <p style="font-size: 2rem;font-weight: 600;margin-left: 20px;">8288 2133</p>
      </div>
    </div>

    <div v-if="calltype" class="pop-win" @click="calltype = false">
        <div class="pop-win-content">
          <a :href="'tel:82882133'" class="pop-win-btn">CALL</a>
          <a :href="'https://api.whatsapp.com/send?phone=82882133'" target="_blank" class="pop-win-btn">WhatsApp</a>
          <!-- <div class="pop-close" @click="calltype = false">X</div> -->
        </div>
    </div>
    <!-- 其他媒体 -->
    <div v-if="showMedia" style="position: absolute;top: 0;left: 0;width: 100%;height: 100%;background-color: black;z-index: 2000;">
      <iframe v-if="ShowType == 'vr'" style="width: 100%;height: 100%;" :src="showMediaData.media" frameborder="0"></iframe>
      <motion v-if="ShowType == 'map'" index="0" btn="true" :zoomsize="zoomsizes" @setzoomsize="setzoomsize">
        <img style="max-width: 100%;max-height: 100%;display: block;" ondragstart="return false;" src="@/assets/172-img/map.png" alt="">
      </motion>
      <motion v-if="ShowType == 'img'" index="0" btn="true" :zoomsize="zoomsizes" @setzoomsize="setzoomsize">
        <img style="max-width: 100%;max-height: 100%;display: block;" ondragstart="return false;" :src="showMediaData.cover" alt="">
      </motion>
      <div @click="showMedia=false" style="position: absolute;top: 49%;right: 20px;color: black;background-color: white;padding: 5px;cursor: pointer;border-radius: 5px;z-index: 999;">Close</div>
    </div>
  </div>
</template>

<script>
import {
  swiperAnimateCache,
  swiperAnimate,
  clearSwiperAnimate,
} from "@/assets/swiper.animate1.0.3.min.js";
import motion from "../components/motion.vue"

export default {
  components: {motion},
  data() {
    return {
      calltype:false,
      zoomsizes:1,
      ShowType: "img",
      swiperOption: {
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        slidesPerView: 1,
        loopedSlides: 0, // looped slides should be the same
        // spaceBetween: 10,
        centeredSlides: true,
        loop:true,
        // autoplay: {
        //     delay: 5000, // 轮播间隔时间，单位为毫秒
        //     disableOnInteraction: false, // 用户操作后是否禁止自动轮播
        //   },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: '.swiper-pagination'
        },
        on: {
          init: function () {
            swiperAnimateCache(this); //隐藏动画元素
            swiperAnimate(this); //初始化完成开始动画
          },
          slideChangeTransitionEnd: function () {
            swiperAnimate(this); //每个slide切换结束时也运行当前slide动画
            //this.slides.eq(this.activeIndex).find('.ani').removeClass('ani'); 动画只展现一次，去除ani类名
          },
        },
      },
      imglist: [
        { index:1,name: "IMG",show:true, type: "img", cover: require("@/assets/172-img/172-6C6D LaVille-v1-2.jpg"),media:"img1" },
        { index:2,name: "IMG",show:true, type: "img", cover: require("@/assets/172-img/172-6C6D LaVille-V2.jpg"),media:"img1" },
        { index:3,name: "IMG",show:true, type: "img", cover: require("@/assets/172-img/172-6C6D LaVille-v3-opt1.jpg"),media:"img1" },
        { index:4,name: "IMG",show:true, type: "img", cover: require("@/assets/172-img/172-6C6D LaVille-v5.jpg"),media:"img1" },
        { index:5,name: "IMG",show:true, type: "img", cover: require("@/assets/172-img/172-6C6D LaVille-v6-3333-1.jpg"),media:"img1" },
        { index:6,name: "IMG",show:true, type: "img", cover: require("@/assets/172-img/172-6C6D LaVille-v4-1.jpg"),media:"img1" },
        { index:7,name: "IMG",show:true, type: "img", cover: require("@/assets/172-img/172-6C6D LaVille-v7.jpg"),media:"img1" },
        { index:8,name: "IMG",show:true, type: "img", cover: require("@/assets/172-img/172-6C6D LaVille-v8-2-1.jpg"),media:"img1" },
      ],
      showMedia:false,
      showMap:false,
      showVR:false,
      showMediaData:{},
    };
  },
  methods: {
    setzoomsize(size){
        this.zoomsizes = size
    },
    padZero(num, length) {
      return String(num).padStart(length, "0");
    },
    showVr(item){
      this.showMedia = true;
      this.ShowType = 'vr';
      this.showMediaData = item
    },
    showMaps(){
      this.showMedia = true;
      this.ShowType = 'map';
    },
    showImg(item){
      this.showMedia = true;
      this.ShowType = 'img';
      this.showMediaData = item
    },
  },
  mounted() {},
};
</script>

<style lang="less">
 
.gallery-group{
  width: 80%;
  margin: auto;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  .gallery-item {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    // width: 320px;
    height: 35vh;
    margin: 10px;
    .item-img{
      position: relative;
      width: 100%;
      height: 90%;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 5px;
      filter: brightness(0.7);
      // filter: brightness(50%);
    }
    h2{
      position: absolute;
      color: #e59c4d;
      text-shadow: 2px 2px 4px #000;
    }
    }

  }
}


.pop-win{
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .pop-win-content {
    // width: 600px;
    // height: 400px;
    position: relative;
    background: #fff;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 10px;
    padding: 40px;
    cursor: pointer;
    .pop-win-btn {
      width: 200px;
      background-color: #ab855c;
      color: #fff;
      padding: 10px 20px;
      margin: 5px;
      border-radius: 10px;
      text-decoration: none;
    }
    .pop-win-btn:hover {
      background-color: #000;
    }
    .pop-close{
      position: absolute;
      top: 0;
      right: 0;
      margin: 10px;
      font-size: 1.2rem;
    }
  }
}

.w50{
  width: 50vw;
}
.w40{
  width: 40%;
}

.home-flex-center{
  display: flex;
  justify-content: center;
  align-items: center;
}

/* 你可以在这里添加自定义样式 */
.swiper-pagination-bullet {
  background-color: #fff !important; /* 白色小点 */
  margin: 0 5px !important; /* 小点之间的间距 */
}
.swiper-pagination-bullet-active {
  background-color: #007aff; /* 激活时的小点颜色 */
}
.swiper-pagination{
  bottom: 10px;
    left: 50%;
    transform: translateX(-50%) !important;
}
.home-bg1{
  background-image: url('~@/assets/172-img/1-2.jpg');
  background-size: cover;
}
.home-bg2{
  background-image: url('~@/assets/172-img/172-6C6D LaVille-V2.jpg');
  background-size: cover;
}
.home{
  width: 100%;
  height: auto;
}
.home-phone-btn{
  margin: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  img{
    width: 65px;
  }
  p{
    margin-left: 10px;
    white-space:nowrap;
  }
}

.image-container{
  position: relative;
}
.image-container::before{
  position: absolute;
  right: 10px;
  bottom: 10px;
  font-size: 10px;
  display: block;
  color: white;
  content: "Artist’s Impression";
}
.image-container img{
  display: block;
}

.flex-start {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
}
.flex-center {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}

.min-font-size {
  font-size: 12px;
}

.swiperInformation {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  color: #ab855c;
  // background-color: rgba(255, 255, 255, 0.151);
  // border-radius: 10px;
  .swiper-slide {
    width: 100%;
    height: 100%;
    overflow-y: auto;
    img {
      object-fit: contain;
      height: 100%;
      width: 100%;
    }
  }
}
.swiper-slide {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  // border-radius: 10px;
  // background-color: #000000;
}
.swiper-button-prev,
.swiper-button-next {
  display: flex;
  justify-content: center;
  align-items: center;
  background: none;
  img {
    max-height: 5rem;
    max-width: 5rem;
  }
}


@media screen and (max-width:800px) {


  .w50{
    width: 80vw;
  }
  .w40{
    width: 80vw;
  }
  .home-flex-center{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
  .swiper-slide{
  align-items: flex-start;

  }
  .gallery-group{
    width: 80%;
    margin: 0;
    grid-template-columns: repeat(1, 1fr);
    .gallery-item{
      margin: 0;
    }
  }
}



</style>

